import { Typography, Grid, Stack } from "@mui/material";
import { useIntl } from "react-intl";
import { H2, P_REGULAR_SEMI_BOLD } from "../../../Constants/CommonConstants";
import PropTypes from "prop-types";
import { StyledPersonalInfoFieldsTypography } from "../../../Styles/AccountCreation/ProviderAndCertifierAccountCreation/ProviderReviewInfoStyles";

/**
 * @description Common component created to display provider personal information fields
 * @param {string} fieldLabel used to provide the id associated with each field value of provider details
 * @param {string} fieldValue displays the field value corresponding to the provider personal information
 * @returns {ReactNode} Renders the provider personal information fields based on the fieldLabel and fieldValue passed as props
 */
export const PersonalInfoFieldDisplay = ({ fieldLabel, fieldValue }) => {
  const intl = useIntl();

  return (
    <Grid item xs={6}>
      <Stack spacing={1.5}>
        <Typography
          component={H2}
          variant={P_REGULAR_SEMI_BOLD}
          id={fieldLabel}
        >
          {intl.formatMessage({ id: fieldLabel })}
        </Typography>
        <StyledPersonalInfoFieldsTypography id={`${fieldLabel}-value`}>
          {fieldValue}
        </StyledPersonalInfoFieldsTypography>
      </Stack>
    </Grid>
  );
};

PersonalInfoFieldDisplay.propTypes = {
  fieldLabel: PropTypes.string.isRequired,
  fieldValue: PropTypes.string.isRequired,
};
